// extracted by mini-css-extract-plugin
module.exports = {"container":"PresentPopup_container__3HF2F","field":"PresentPopup_field__2JLLB","skeleton-anim":"PresentPopup_skeleton-anim__2OmMF","fadeIn1":"PresentPopup_fadeIn1__2FnQl"};